import script from "./StudentTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentTable.vue?vue&type=script&setup=true&lang=js"

import "./StudentTable.vue?vue&type=style&index=0&id=cc717ede&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc717ede"]])

export default __exports__